const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

class SettingsService {
  async getSettings() {
    try {
      const response = await fetch(`${API_BASE_URL}/api/settings`);
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Error al obtener la configuración');
      return data;
    } catch (error) {
      console.error('Error en getSettings:', error);
      throw error;
    }
  }

  async updateAISettings(aiConfig) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/settings/ai`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(aiConfig),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Error al actualizar');
      return data;
    } catch (error) {
      console.error('Error en updateAISettings:', error);
      throw error;
    }
  }

  async testAISettings(aiConfig) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/settings/ai/test`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(aiConfig),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Error en la prueba de conexión');
      return data;
    } catch (error) {
      console.error('Error en testAISettings:', error);
      throw error;
    }
  }

  async updateProposalConfig(config) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/settings/proposals`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(config),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Error al actualizar');
      return data;
    } catch (error) {
      console.error('Error en updateProposalConfig:', error);
      throw error;
    }
  }

  async updateProjectConfig(config) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/settings/projects`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(config),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Error al actualizar');
      return data;
    } catch (error) {
      console.error('Error en updateProjectConfig:', error);
      throw error;
    }
  }

  async addKnowledgeEntry(entry) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/settings/knowledge`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(entry),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Error al agregar');
      return data;
    } catch (error) {
      console.error('Error en addKnowledgeEntry:', error);
      throw error;
    }
  }

  async updateKnowledgeEntry(entryId, updates) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/settings/knowledge/${entryId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updates),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Error al actualizar');
      return data;
    } catch (error) {
      console.error('Error en updateKnowledgeEntry:', error);
      throw error;
    }
  }

  async deleteKnowledgeEntry(entryId) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/settings/knowledge/${entryId}`, {
        method: 'DELETE',
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Error al eliminar');
      return data;
    } catch (error) {
      console.error('Error en deleteKnowledgeEntry:', error);
      throw error;
    }
  }
}

export default new SettingsService();
